/*
 * @Author: LZT
 * @Date: 2023-02-20 16:31:04
 * @LastEditors: LZT
 * @Description:
 * @FilePath: \qs\src\stores\user.js
 */
import { defineStore } from "pinia";

const useUsersStore = defineStore("users", {
  state: () => ({
    newUserInfo: {},
    barHeight: 0, // 导航栏高度
    tabBarActive: "", // 当前选中的底部导航栏
    loginPopup: false, // 登录弹窗提示
    screenSharingPopup: false, // 屏幕共享弹窗提示
    screenSharingRoomId: "", // 屏幕共享房间id
    screenSharingUserName: "", // 屏幕共享用户名
    screenSharingUserAvatar: "", // 屏幕共享用户头像
  }),
  actions: {
    setNewUserInfo (info) {
      this.newUserInfo = info;
    },
    setNavBarHeight (status) {
      this.barHeight = status;
    },
    setTabBarActive (status) {
      this.tabBarActive = status;
    },
    setLoginPopup (status) {
      this.loginPopup = status;
    },
    setScreenSharingPopup (status) {
      this.screenSharingPopup = status;
    },
    setScreenSharingRoomId (status) {
      this.screenSharingRoomId = status;
    },
    setScreenSharingUserName (status) {
      this.screenSharingUserName = status;
    },
    setScreenSharingUserAvatar (status) {
      this.screenSharingUserAvatar = status;
    },
  },
  // persist: true, // 所有数据持久化
  // 持久化存储插件其他配置
  persist: {
    debug: true,
    // 修改存储中使用的键名称，默认为当前 Store的 id
    key: "SET_USER_INFO",
    // 修改为 sessionStorage，默认为 localStorage
    storage: localStorage,
    // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
    paths: ["newUserInfo"]
  }
});
export default useUsersStore;
